import React from "react";

import moment from "moment";

import InputSelectField from "./InputSelectField";
import InputDateField from "./InputDateField";
import InputTextField from "./InputTextField";

import "./ParkerStatus.scss";

class ParkerStatusTableAddRow extends React.Component {
  render() {
    const {
      fieldConfiguration,
      onChange,
      showErrors,
      getDates,
      showAccessStatus,
      reqError,
      inputs: {
        selectedAction,
        selectedSuspensionStartDate,
        selectedSuspensionEndDate,
        terminationDate,
        isNoEndDate,
        notes,
      },
    } = this.props;

    const action = fieldConfiguration.parkerStatusHistoryAction.options;

    const checkDate =
      showErrors &&
      selectedAction === "SUSPEND" &&
      selectedSuspensionEndDate !== null && selectedSuspensionStartDate !== null &&
      !moment(selectedSuspensionStartDate).isBefore(
        selectedSuspensionEndDate
      ) &&
      !isNoEndDate;

    return (
      <div className="parkerstatus-line-item-entry-table-row">
        <div className="parkerstatus-line-item-entry-table--date-recorded-column parkerstatus-line-item-entry-table--cell"></div>
        <div className="parkerstatus-line-item-entry-table--action-column parkerstatus-line-item-entry-table--cell">
          <InputSelectField
            id="parkerstatus-line-item-entry-table--action-input"
            options={[
              { value: null, label: "" },
              ...action.filter(
                (action) => ![
                  "PARKER_START_DATE",
                  "BLOCK_ACCESS",
                  "ACCESS_SYSTEM_START_DATE"
                ].includes(action.value)
              ),
            ]}
            value={selectedAction}
            onChange={onChange("selectedAction")}
            editMode={true}
          />
        </div>
        <div className="parkerstatus-line-item-entry-table--parker-start-date-column parkerstatus-line-item-entry-table--cell"></div>
        {showAccessStatus && (
          <div className="parkerstatus-line-item-entry-table--access-status-column parkerstatus-line-item-entry-table--cell"></div>
        )}
        <div
          className={`parkerstatus-line-item-entry-table--sus-start-date-column parkerstatus-line-item-entry-table--cell ${
            (showErrors && selectedSuspensionStartDate === null) && "show-error"
          }`}
        >
          {(!selectedAction || selectedAction === "SUSPEND") && (
            <>
              <InputSelectField
                id="parkerstatus-line-item-entry-table--start-date-input"
                options={getDates("startDate")}
                value={selectedSuspensionStartDate}
                editMode={true}
                onChange={onChange("selectedSuspensionStartDate")}
              />
              <span className="error">
                {(showErrors &&
                  selectedSuspensionStartDate === null) &&
                  "Please provide a Suspension Start Date"}
              </span>
            </>
          )}
        </div>
        <div
          className={`parkerstatus-line-item-entry-table--sus-end-date-column parkerstatus-line-item-entry-table--cell ${
            ((showErrors && selectedSuspensionEndDate === null) ||
              checkDate ||
              reqError) &&
            "show-error"
          }`}
        >
          {(!selectedAction || selectedAction === "SUSPEND") && (
            <>
              <InputSelectField
                id="parkerstatus-line-item-entry-table--action-input"
                options={getDates("endDate")}
                value={selectedSuspensionEndDate}
                editMode={true}
                disabledMode={isNoEndDate}
                onChange={onChange("selectedSuspensionEndDate")}
              />
              <span className="error">
                {showErrors &&
                  selectedSuspensionEndDate === null &&
                  !isNoEndDate &&
                  "Please provide a Suspension End Date"}
              </span>
              <span className="error">
                {checkDate && "Please review suspension dates selected"}
              </span>
              <span className="error">{reqError}</span>
            </>
          )}
        </div>
        <div className="parkerstatus-line-item-entry-table--no-end-date-column parkerstatus-line-item-entry-table--cell">
          {(!selectedAction || selectedAction === "SUSPEND") && (
            <input
              type="checkbox"
              checked={isNoEndDate}
              onChange={(e) => {
                onChange("isNoEndDate")(e.target.checked);
                setTimeout(() => {
                  onChange("selectedSuspensionEndDate")(null);
                }, 10);
              }}
            />
          )}
        </div>
        <div className={`parkerstatus-line-item-entry-table--termination-date-column parkerstatus-line-item-entry-table--cell ${reqError && "show-error"}`}>
          {(!selectedAction || selectedAction === "TERMINATE") && (
            <>
              <InputDateField
                id="parkerstatus-line-item-entry-table--suspension-end-date-input"
                value={terminationDate}
                editMode={true}
                showError={showErrors && terminationDate === null}
                errorMessage="Please provide a Termination Date"
                onChange={onChange("terminationDate")}
              />
              <span className="error">{reqError}</span>
            </>
          )}
        </div>
        <div className="parkerstatus-line-item-entry-table--notes-column parkerstatus-line-item-entry-table--cell">
          <InputTextField
            inputId="parkchirp--transaction-table--notes"
            value={notes}
            multiLine={true}
            editMode={true}
            onChange={onChange("notes")}
            maxlength="255"
          />
        </div>
      </div>
    );
  }
}

export default ParkerStatusTableAddRow;
